import { useParams } from 'react-router';

export function useRouteParams<T extends { [K in keyof T]?: string }>(): T {
  return useParams<T>();
}
